/**
 * Countries the Linx `select-country` step offers.
 *
 * Not configurable per template: KOR-14907 asks only that customers be able to link Canadian
 * accounts as well as US ones, so every bank-linking workflow offers both. Sent explicitly rather
 * than relying on `SelectCountryProcessorImpl.DEFAULT_ALLOWED_COUNTRY_CODES` so the offered set is
 * visible here rather than changing silently underneath us.
 *
 * Values are ISO3 because that is what KOR stores in `workflow_data.data.countryCode` and what the
 * customer app submits. Do not switch these to ISO2.
 */
export const LINX_ALLOWED_COUNTRY_CODES = ['USA', 'CAN'];

/**
 * Card accounts never reach Flinks, so a country step ahead of one would ask a question that
 * changes nothing. `DEBIT` is the value the template payload carries for a card.
 */
export const linkCountryStepApplies = (financialAccountSubType?: string): boolean =>
  financialAccountSubType !== 'CARD' && financialAccountSubType !== 'DEBIT';
